// extracted by mini-css-extract-plugin
module.exports = {"Select":"RecordingAffectOptions_Select__7GTAY","SelectLabel":"RecordingAffectOptions_SelectLabel__22qOx","OptionsContainer":"RecordingAffectOptions_OptionsContainer__3OwnS"};